import { OnInit, Component, EventEmitter, Output, Input, ViewChild } from '@angular/core';
import { OrganisationSettingEnum } from '../../enums/organisation-settings';
import { OrganisationsService } from '../../services';
import { Dialog, SelectItem } from 'primeng';
import { OrganisationSettingService } from '../../services';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { compare } from 'fast-json-patch';
import { DatePipe } from '@angular/common';
import unshift from 'core-js/fn/array/unshift';

@Component({
  selector: 'organisation-custom-settings',
  templateUrl: './organisation-custom-settings.component.html',
  styleUrls: ['./organisation-custom-settings.scss'],
})
export class OrganisationCustomSettingsComponent implements OnInit {
  setting: any;
  organisationId: number;
  organisationList: SelectItem[];
  settingList: object[] = [];
  organisationResult: string[];

  @ViewChild('editSettingDialog') editSettingDialog: Dialog;
  showEditDialog: boolean = false;
  settingName: any;
  settingLookup: string[] = [];
  organisationName: any;
  orgSettingsList: any;
  canCreate: boolean = false;
  canCreateDefault: boolean = false;
  public formGroup: UntypedFormGroup;
  formOrganisationName: string;
  formOrganisationId?: number;
  private beforeForm: any;

  constructor(
    private organisationService: OrganisationsService,
    private formBuilder: UntypedFormBuilder,
    private datePipe: DatePipe,
    private organisationSettingService: OrganisationSettingService,
  ) {}

  ngOnInit() {
    this.initSettingList();
    this.initOrgList();
    this.initEditForm();
  }

  initOrgList() {
    this.organisationService.getSelectList({}).then((x) => {
      this.organisationList = x;
      unshift(this.organisationList, { value: null, label: 'Select Organisation' });
    });
  }

  initSettingList() {
    this.settingList.push({ value: null, label: 'Select Setting' });

    for (const keyValue in Object.keys(OrganisationSettingEnum)) {
      if (OrganisationSettingEnum[keyValue] !== undefined) {
        let label = OrganisationSettingEnum[keyValue].replace(/([A-Z])/g, ' $1').trim();
        this.settingList.push({ value: keyValue, label: label });
        this.settingLookup[keyValue] = OrganisationSettingEnum[keyValue];
      }
    }

    console.log('SL ', this.settingLookup);
  }

  filterOrgs(event: any) {
    this.organisationId = null;
    const cloneList = Object.assign([], this.organisationList);
    const organisations = cloneList.filter(
      (x) => x.label.toLowerCase().includes(event.query.toLowerCase()) > 0,
    );
    this.organisationResult = organisations.map((x) => x.label);
  }

  searchSettings() {
    return this.organisationSettingService
      .search({
        organisationId: this.organisationId,
        setting: this.setting,
        includeOrganisation: true,
        component: 'organisation-custom-settings',
      })
      .then((x) => {
        this.orgSettingsList = x;

        this.canCreate = x.filter((x) => x.organisationId == this.organisationId).length == 0;

        this.canCreateDefault =
          this.organisationId == null && x.filter((z) => z.organisationId == null).length == 0;
      });
  }

  orgSelected($event: any) {
    const organisation = this.organisationList.filter((x) => x.label == $event)[0];

    this.organisationId = organisation === undefined ? null : organisation.value;
    this.organisationName = organisation === undefined ? null : organisation.label;
    this.formOrganisationName = organisation === undefined ? null : organisation.label;

    console.log('FON ', this.formOrganisationName);

    this.runSearch();
  }

  settingSelected($event: any) {
    this.runSearch();
  }

  runSearch() {
    if (this.organisationId != null || this.setting != null) {
      this.searchSettings().then(() => {});
    }
  }

  edit(data) {
    this.showEditDialog = true;

    console.log('DATA ', data);

    this.formOrganisationName = data.organisationName;
    this.formOrganisationId = data.organisationId;

    console.log('DATA', data);

    this.formGroup.patchValue({
      id: data.id,
      organisationId: data.organisationId,
      setting: data.setting,
      intValue: data.intValue,
      charValue: data.charValue,
      dateTimeValue: this.datePipe.transform(data.dateTimeValue, 'yyyy-MM-dd HH:mm:ss'),
    });

    this.beforeForm = this.formGroup.value;
  }

  create(organisationId: number) {
    this.formOrganisationId = organisationId;

    this.formGroup.patchValue({
      id: null,
      organisationId: this.organisationId,
      setting: this.setting,
      intValue: null,
      charValue: '',
      dateTimeValue: null,
    });

    this.beforeForm = this.formGroup.value;

    this.showEditDialog = true;
  }

  get f() {
    return this.formGroup.value;
  }

  saveCustomSetting() {
    console.log('ID ', this.f.id);

    if (this.f.id != null) {
      let formValues = this.formGroup.value;
      let newPatch = compare(this.beforeForm, formValues);

      this.organisationSettingService.patch(this.f.id, newPatch).then((x) => {
        this.showEditDialog = false;
        this.runSearch();
      });
    } else {
      this.organisationSettingService.create(this.f).then((x) => {
        this.showEditDialog = false;
        this.runSearch();
      });
    }
  }

  private initEditForm() {
    this.formGroup = this.formBuilder.group({
      id: [''],
      organisationId: [''],
      setting: [''],
      intValue: [''],
      charValue: [''],
      dateTimeValue: [''],
    });
  }

  deleteCustomSetting() {
    this.organisationSettingService.delete(this.f.id).then((x) => {
      this.showEditDialog = false;
      this.runSearch();
    });
  }
}
